import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import HTopbar from '../../hooks/HomeTopBar';
import { fetchSecurityQuestions } from '@/lib/api/SecurityQuestion';

const SecurityRecover = () => {
  const [allQuestions, setAllQuestions] = useState([]);
  const [selectedQuestions, setSelectedQuestions] = useState(Array(5).fill(''));
  const [answers, setAnswers] = useState({});

  useEffect(() => {
    const loadQuestions = async () => {
      try {
        const response = await fetchSecurityQuestions();
        setAllQuestions(response);
      } catch (error) {
        console.error('Error fetching questions:', error);
      }
    };
    loadQuestions();
  }, []);

  const handleQuestionChange = (index, questionId) => {
    const newSelected = [...selectedQuestions];
    newSelected[index] = questionId;
    setSelectedQuestions(newSelected);
  };

  const handleAnswerChange = (questionId, value) => {
    setAnswers((prev) => ({ ...prev, [questionId]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Selected:', selectedQuestions);
    console.log('Answers:', answers);
    // You can send this data to your backend
  };

  return (
    <div className="vh-100 vw-100 d-flex flex-column bg-white">
      <HTopbar />
      <div className="container-fluid flex-grow-1 d-flex align-items-center justify-content-center">
        <div
          className="row w-100 shadow rounded-4 overflow-hidden"
          style={{ maxWidth: '1100px', minHeight: '400px', height: '80vh' }} // increased maxWidth
        >
          {/* Left Visual */}
          <div className="col-md-6 d-none d-md-block p-0">
            <img
              src="/images/login.jpg"
              alt="Security Visual"
              className="w-100 h-100"
              style={{ objectFit: 'cover' }}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = '';
              }}
            />
          </div>

          {/* Right Form */}
          <div className="col-md-6 bg-white p-4 d-flex flex-column justify-content-center" style={{ overflowY: 'auto', maxHeight: '80vh' }}>
            <div className="text-center mb-3">
              <h1 className="fw-bold text-dark" style={{ fontSize: '2.2rem' }}>
                Match<span className="text-secondary">Up</span>
              </h1>
              <p className="text-muted mt-2">
                Choose and answer 5 security questions to recover your account.
              </p>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="row g-2 mb-3">
                {selectedQuestions.map((selectedId, index) => {
                  return (
                    <div key={index} className="col-md-12 mb-2">
                      <label className="form-label text-muted mb-1">
                        {index + 1}. Choose a security question
                      </label>
                      <select
                        className="form-select mb-1"
                        value={selectedId}
                        onChange={(e) => handleQuestionChange(index, e.target.value)}
                      >
                        <option value="">-- Select a question --</option>
                        {allQuestions.map((q) => (
                          <option key={q.id} value={q.id} disabled={selectedQuestions.includes(q.id)}>
                            {q.question_text}
                          </option>
                        ))}
                      </select>
                      {selectedId && (
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Your answer"
                          value={answers[selectedId] || ''}
                          onChange={(e) => handleAnswerChange(selectedId, e.target.value)}
                        />
                      )}
                    </div>
                  );
                })}
              </div>

              <div className="d-grid mt-2">
                <button type="submit" className="btn btn-dark btn-lg rounded-pill">
                  Proceed
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecurityRecover;
